export default __webpack_public_path__ + "static/media/penguin.0132e765.png";